module.exports = __webpack_public_path__ + "static/media/icon_delete.0bc0da3e.png";